import _ from 'lodash';
import { ISession } from '@/types';
import { SESSION_STATUS } from '@/constants';

export const needsActionCheck = (args: {
  needsAction: boolean;
  needsActionFrom: string[];
  userId: string;
}) => {
  const { needsAction, needsActionFrom, userId } = args;
  if (!needsAction) {
    return false;
  }

  return needsActionFrom.length === 0 || needsActionFrom.includes(userId);
};

export const applySessionFilter = (
  sessions: ISession[] = [],
  userId = '',
  options: {
    needsAction: boolean;
    tags: string[] | { [operator: string]: string[]; };
    status: string | string[];
    claimedBy: string;
    claimedByHistory: string;
  }
) => {
  const result = sessions.filter(session => {
    if (!_.isEmpty(options.tags)) {
      const operator = _.isArray(options.tags)
        ? 'OR'
        : Object.keys(options.tags)[0];

      const tags = _.isArray(options.tags)
        ? options.tags
        : Object.values(options.tags)[0];

      /* Session has to include any of  provided tags */
      if (operator === 'OR') {
        const hasAnyTag = _.intersection(tags, session.tags);
        if (!hasAnyTag.length) {
          return false;
        }
      }

      /* Session has to include all of provided tags */
      if (operator === 'AND') {
        const hasTags = _.difference(tags, session.tags);
        if (hasTags.length) {
          return false;
        }
      }
    }

    /* Positive value either explicitly includes or excludes a session */
    if (session.needsAction) {
      return options.needsAction;
    }

    /* Session with any status which once was claimed by the current agent */
    if (options.claimedByHistory) {
      return session.claimedByHistory.includes(userId);
    }

    /**
     * Session has to have a status, specified by filter.
     * A full list of statuses is provided by default.
     */
    const statuses = options.status || [];
    if (!statuses.includes(session.status)) {
      return false;
    }

    if (options.claimedBy && session.status !== SESSION_STATUS.ONGOING) {
      if (!session.claimedBy.includes(userId)) {
        return false;
      }
    }

    return true;
  });

  return result;
};
